import ScreenLayout from '@/components/layout/ScreenLayout'
import RouteErrorPage, { type RouteErrorPageProps } from '@/components/layout/RouteErrorPage'
import SignalsLocked from '@/screens/signals/components/SignalsLocked'
import { signalsRailProps } from '@/screens/signals/components/signals-rail'
import { isSignalsLocked } from '@/screens/signals/lib/signals-ui'

interface SignalsRouteErrorProps extends RouteErrorPageProps {
  /** The TitleRow's words, for the rail's "Ask about this page". */
  pageTitle: string
}

/**
 * Every Signal Zone route's `errorComponent`: a refused read (403, D4) is the
 * locked state in the page's own frame, and anything else is the route's
 * failed page with the same header the pending page drew. That failed page
 * keeps the shared rail: `RouteErrorPage` takes no rail, and the layout
 * family is locked (owner 2026-10-12).
 *
 * Kept to the error page, the layout, the rail and the upgrade block, as an
 * `errorComponent` ships in the entry chunk (docs/route-loading.md, "Error
 * components") — Alerts' error page carries the same upgrade block.
 */
export default function SignalsRouteError({ pageTitle, ...props }: SignalsRouteErrorProps) {
  if (isSignalsLocked(props.error)) {
    return (
      <ScreenLayout header={props.header} {...signalsRailProps(pageTitle)}>
        <SignalsLocked error={props.error} />
      </ScreenLayout>
    )
  }
  return <RouteErrorPage {...props} />
}
